import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../utils/axios";
import {
    CALL_PPOR_API,
    MIDDLE_WARE_BASE_URL_v1,
} from "../../../../utils/CONSTANTS";

const initialState = {
    getResourceLinkState: '',
    getResourceLinkData: '',
};
export const getResourceLink = createAsyncThunk(
    "get/getResourceLinks",
    async (data: any) => {
        const response = axios.postStringRequest(
            MIDDLE_WARE_BASE_URL_v1() + CALL_PPOR_API(),
            data
        );
        return response;
    }
);

const getResourceLinkSlice = createSlice({
    name: "getResourceLink",
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(getResourceLink.pending, (state) => {
                state.getResourceLinkState = "pending";
            })
            .addCase(getResourceLink.fulfilled, (state, action) => {
                let tempRes = action.payload.data?.response;
                if (typeof tempRes === "string") {
                    tempRes = JSON.parse(tempRes);
                    // console.log(tempRes);
                }
                state.getResourceLinkState = "fulfilled";
                state.getResourceLinkData = tempRes?.response?.resource;
                // console.log("getResourceLinkData", state.getResourceLinkData);
            })
            .addCase(getResourceLink.rejected, (state) => {
                state.getResourceLinkState = "failed";
            })
});

export const getResourceLinks = (state: any) => state.getResourceLink || {};

export default getResourceLinkSlice.reducer;
